/**
 * Structured Data (JSON-LD) Generators for ISAAC Logistic Solutions India Pvt. Ltd.
 */

export const getOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://www.isaacgroup.net/#organization',
  'name': 'ISAAC Logistic Solutions India Pvt. Ltd.',
  'legalName': 'ISAAC Logistic Solutions India Pvt. Ltd.',
  'url': 'https://www.isaacgroup.net',
  'logo': 'https://www.isaacgroup.net/logo512.png',
  'description': 'Women-led shipping agency and logistics entity in India delivering vessel husbanding, project cargo, freight forwarding, customs clearance, and green port electrification.',
  'email': 'info@isaacgroup.net',
  'telephone': '+91 70107 55885',
  'address': {
    '@type': 'PostalAddress',
    'streetAddress': 'SF. No.156/1, Plot 3/436-66, Isaac Street, Central State Govt Employee Colony, Kumaragiri, Pudukkottai',
    'addressLocality': 'Thoothukudi',
    'addressRegion': 'Tamil Nadu',
    'postalCode': '628103',
    'addressCountry': 'IN'
  },
  'sameAs': [
    'https://linkedin.com',
    'https://facebook.com',
    'https://instagram.com',
    'https://youtube.com'
  ]
});

export const getLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': 'https://www.isaacgroup.net/#localbusiness',
  'name': 'ISAAC Logistic Solutions India Pvt. Ltd.',
  'image': 'https://www.isaacgroup.net/logo512.png',
  'url': 'https://www.isaacgroup.net',
  'telephone': '+91 70107 55885',
  'email': 'info@isaacgroup.net',
  'priceRange': '$$',
  'address': {
    '@type': 'PostalAddress',
    'streetAddress': 'SF. No.156/1, Plot 3/436-66, Isaac Street, Central State Govt Employee Colony, Kumaragiri, Pudukkottai',
    'addressLocality': 'Thoothukudi',
    'addressRegion': 'Tamil Nadu',
    'postalCode': '628103',
    'addressCountry': 'IN'
  },
  'geo': {
    '@type': 'GeoCoordinates',
    'latitude': 8.7642,
    'longitude': 78.1348
  },
  'openingHoursSpecification': {
    '@type': 'OpeningHoursSpecification',
    'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    'opens': '09:00',
    'closes': '18:00'
  },
  'areaServed': [
    { '@type': 'Country', 'name': 'India' },
    { '@type': 'AdministrativeArea', 'name': 'Tamil Nadu' },
    { '@type': 'AdministrativeArea', 'name': 'Kerala' },
    { '@type': 'City', 'name': 'Thoothukudi' },
    { '@type': 'City', 'name': 'Vizhinjam' },
    { '@type': 'City', 'name': 'Chennai' }
  ]
});

export const getServiceSchemas = () => [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    'serviceType': 'Contract Staffing and Manpower Supply',
    'name': 'Contract Staffing and Manpower Supply',
    'provider': { '@type': 'LocalBusiness', 'name': 'ISAAC Logistic Solutions India Pvt. Ltd.' },
    'areaServed': 'India',
    'url': 'https://www.isaacgroup.net/services#contract-staffing',
    'description': 'Skilled and unskilled manpower for manufacturing, ports, terminals, warehouses and logistics, with contract staffing and workforce coordination.'
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    'serviceType': 'Shipping Agency, Vessel Husbanding, Transshipment & ODC',
    'name': 'Shipping Agency, Vessel Husbanding & ODC Logistics Services',
    'provider': {
      '@type': 'LocalBusiness',
      'name': 'ISAAC Logistic Solutions India Pvt. Ltd.'
    },
    'areaServed': 'India',
    'description': 'Full shipping agency representation, vessel husbanding, transshipment logistics, ODC transportation, clearance, and owner representation at Thoothukudi VOC Port, Vizhinjam Port, and Chennai Port.'
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    'serviceType': 'Freight Forwarding & Customs Clearance',
    'name': 'Freight Forwarding & Customs Clearance Services',
    'provider': {
      '@type': 'LocalBusiness',
      'name': 'ISAAC Logistic Solutions India Pvt. Ltd.'
    },
    'areaServed': 'Worldwide',
    'description': 'Global sea and air freight forwarding, container freight station (CFS) management, and customs house agency (CHA) clearances.'
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    'serviceType': 'Project Cargo & Heavy Lift Logistics',
    'name': 'Project Cargo & Heavy Lift Logistics',
    'provider': {
      '@type': 'LocalBusiness',
      'name': 'ISAAC Logistic Solutions India Pvt. Ltd.'
    },
    'areaServed': 'India',
    'description': 'Specialized heavy lift and windmill component transportation from port to site.'
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    'serviceType': 'Green Energy & Port Electrification',
    'name': 'Green Energy & Port Electrification Solutions',
    'provider': {
      '@type': 'LocalBusiness',
      'name': 'ISAAC Logistic Solutions India Pvt. Ltd.'
    },
    'areaServed': 'India',
    'description': 'High-voltage shore connection (HVSC cold ironing), terminal electrification, and decarbonized vessel heating systems in partnership with Shanghai Hissen.'
  }
];

export const getBreadcrumbSchema = (items = []) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  'itemListElement': items.map((item, index) => ({
    '@type': 'ListItem',
    'position': index + 1,
    'name': item.name,
    'item': item.url
  }))
});
